<div class="quickpanel">Tu peux ajouter des composants ici</div>
